module.exports = __webpack_public_path__ + "static/media/Archives.e86968a5.md";